import {
	Bell,
	Bot,
	Camera,
	ClipboardX,
	Cpu,
	Download,
	Eye,
	EyeOff,
	Fullscreen,
	Highlighter,
	Home,
	IdCard,
	Keyboard,
	Laptop,
	MapPin,
	MessageCircle,
	Mic,
	Monitor,
	MonitorCheck,
	MousePointerClick,
	Power,
	Printer,
	ScanSearch,
	ShieldOff,
	Smartphone,
	Upload,
	UserCheck,
	Users,
	UserX,
	Video,
	Expand,
} from 'lucide-react';

/** Distinct icon per entity key. Never reuse across unrelated feature groups. */
const entityIcons = {
	// Recording
	record_video: Video,
	track_location: MapPin,
	record_room: Home,
	record_screen: Monitor,
	record_audio: Mic,
	mobile_proctoring: Smartphone,

	// Lockdown
	force_full_screen: Fullscreen,
	disable_right_click: MousePointerClick,
	detect_resizing_of_window: Expand,
	disable_clipboard: ClipboardX,
	disable_printing: Printer,
	camera_view: Camera,
	notify: Bell,
	force_closure: Power,
	detect_unfocus: EyeOff,
	disable_keyboard_shortcuts: Keyboard,
	allow_incognito_mode: Eye,
	disable_tampering: ShieldOff,
	disable_highlight_text: Highlighter,

	// Verification
	verify_id: IdCard,
	verify_candidate: UserCheck,
	verify_desktop: MonitorCheck,
	verify_multiple_devices: Laptop,

	// System
	verify_upload_speed: Upload,
	verify_ram: Cpu,
	verify_download_speed: Download,

	// AI
	multiple_people: Users,
	person_missing: UserX,
	object_detection: ScanSearch,

	// Quiz tools
	chat_bot: Bot,
	live_chat: MessageCircle,
};

export const categoryAccent = {
	recording: 'recording',
	lockdown: 'lockdown',
	verification: 'verification',
	system: 'system',
	ai: 'ai',
	'quiz-tools': 'quiz',
};

export default entityIcons;
